/**
 * Stapel offener Ebenen (Dialoge, Popover). Escape/Tab-Fang behandelt nur die oberste Ebene – sonst würde
 * z. B. Escape in einem Emoji-Picker innerhalb eines Dialogs beide schließen (beide hören in der Capture-Phase
 * auf `document`, stopPropagation hilft am selben Knoten nicht).
 */
import { useCallback, useLayoutEffect, useState } from 'react';

/**
 * Registrierte Ebenen mit ihrer Ordnungszahl. Die Zahl wird beim ersten Rendern vergeben – React rendert
 * Eltern vor Kindern, Effekte laufen dagegen Kind vor Eltern. So liegt ein Popover, das zusammen mit seinem
 * Dialog eingehängt wird, trotzdem über diesem.
 */
const active = new Set<number>();
let seq = 0;

/** Registriert die Ebene für die Lebensdauer der Komponente; liefert „bin ich oben?". */
export function useLayer(): () => boolean {
  const [order] = useState(() => ++seq);
  useLayoutEffect(() => {
    active.add(order);
    return () => {
      active.delete(order);
    };
  }, [order]);
  return useCallback(() => {
    if (!active.has(order)) return false;
    for (const o of active) if (o > order) return false;
    return true;
  }, [order]);
}
